import { NgModule } from '@angular/core';
import { Routes, RouterModule, NoPreloading } from '@angular/router';
import { AuthLoginGuard } from './shared/guard/authLogin.guard';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule),
    // canActivate: [AuthLoginGuard]
  },
  {
    path: '',
    loadChildren: () => import('./app-secured/app-secured.module').then(m => m.AppSecuredModule),
    // canActivate: [AuthGuard], canActivateChild: [AuthGuard]
  },
  {
    path: 'register',
    loadChildren: () => import('./register/register.module').then(m => m.RegisterModule),
    // canActivate: [AuthLoginGuard]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top', preloadingStrategy: NoPreloading })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
